import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardBody, Col,
} from 'reactstrap';
import ReactTableBase from '../../../../shared/components/table/ReactTableBase';
import ReactTableActions from './ReactTableActions';

const reorder = (rows, startIndex, endIndex) => {
  const result = Array.from(rows);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const DataReactTable = ({
  title,
  reactTableData,
  ReactTableActions,
  callbackRadioPharmacy,
  callbackTenCorrect,
  callbackFallingRisks,
  Callback,
  callbackupdateCanalization,
  sendNotificationDiagnosticImage,
  refresh,
  handlerIndexPage,
  indexPageForm = 0,
  callbackHealthProfessional
}) => {
  const [rows, setData] = useState(reactTableData.tableRowsData);
  const isEditable = false;
  const isResizable = false;
  const isSortable = false;
  const withDragAndDrop = false;
  const withPagination = true;
  const withSearchEngine = false;

  useEffect(() => {
    setData(reactTableData.tableRowsData)
  }, [reactTableData.tableRowsData]);

  const updateDraggableData = (result) => {
    const items = reorder(
      rows,
      result.source.index,
      result.destination.index,
    );
    setData(items);
  };

  const updateEditableData = (rowIndex, columnId, value) => {
    setData(old => old.map((item, index) => {
      if (index === rowIndex) {
        return {
          ...old[rowIndex],
          [columnId]: value,
        };
      }
      return item;
    }));
  };

  const tableConfig = {
    isEditable,
    isResizable,
    isSortable,
    withDragAndDrop,
    withPagination,
    withSearchEngine,
    manualPageSize: [10, 20, 30, 40],
    placeholder: 'Buscar',
    useActions: true,
    indexPageForm: indexPageForm,
    handlerIndexPage,
    actions: (data, state) => ReactTableActions({ data, state, callbackRadioPharmacy, callbackTenCorrect, Callback, callbackupdateCanalization, sendNotificationDiagnosticImage, refresh, indexPageForm, callbackHealthProfessional, callbackFallingRisks }),
  };

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <ReactTableBase
            key={withSearchEngine || isResizable || isEditable ? 'modified' : 'common'}
            columns={reactTableData.tableHeaderData}
            data={rows}
            updateEditableData={updateEditableData}
            updateDraggableData={updateDraggableData}
            tableConfig={tableConfig}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

DataReactTable.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableHeaderData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableRowData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};

export default DataReactTable;
